import { Color } from '@engineering11/ui-lib/e11-ui-config'

export enum ChipType {
  Incomplete = 'Incomplete',
  CultureIndex = 'Culture Index',
  UpdateRequested = 'Update Requested',
  DialogueAvailable = 'Interview Session',
  Withdrawn = 'Withdrawn',
  ApplicationDeclined = 'Application Declined',
  ClosedByEmployer = 'Closed By Employer',
  ArchivedOriginal = 'Rejected',
  ActiveReassignment = 'Application Reassigned',
  ApplicationCopied = 'Application Copied',
}

export interface IApplicationChip {
  type: ChipType
  color: Color
  icon?: string
  tooltip?: string
}

export const typeToColor: { [key: string]: Color } = {
  [ChipType.Incomplete]: 'complimentary',
  [ChipType.UpdateRequested]: 'purple',
  [ChipType.DialogueAvailable]: 'secondary',
  [ChipType.CultureIndex]: 'primary-accent',
  [ChipType.Withdrawn]: 'neutral',
  [ChipType.ApplicationDeclined]: 'error',
  [ChipType.ClosedByEmployer]: 'neutral',
  [ChipType.ArchivedOriginal]: 'neutral',
  [ChipType.ActiveReassignment]: 'primary-accent',
  [ChipType.ApplicationCopied]: 'primary-accent',
}

export const typeToIcon: { [key: string]: string } = {
  [ChipType.Incomplete]: '',
  [ChipType.UpdateRequested]: 'quiz',
  [ChipType.DialogueAvailable]: 'question_answer',
  [ChipType.Withdrawn]: '',
  [ChipType.CultureIndex]: '',
  [ChipType.ApplicationDeclined]: 'not_interested',
  [ChipType.ClosedByEmployer]: '',
  [ChipType.ArchivedOriginal]: '',
  [ChipType.ActiveReassignment]: 'question_answer',
  [ChipType.ApplicationCopied]: 'question_answer',
}

export type ApplicationChipsDict = { [jobPostId: string]: IApplicationChip[] }
